import { Box, Text } from 'rebass';
import { height, space, width } from 'styled-system';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import styled from 'styled-components';

import { colors } from '../styles/theme';

export const StyledAvatar = styled.div.attrs(({ size, border, backgroundUrl }) => ({
  style: {
    backgroundImage: `url(${backgroundUrl})`,
    borderWidth: border ? '2px' : '0px',
    fontSize: `${size / 2.7}px`,
  },
}))`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e6e6e6;
  background-size: cover;
  background-position: center center;
  border-radius: 50%;
  font-weight: bold;
  text-transform: uppercase;
  ${height};
  ${width};
  ${space};

  /* safari was rendering wrong using the border shorthand' */
  border-style: solid;
  border-color: #fff;

  .fa {
    font-size: 2em;
  }
`;

const Avatar = ({ avatarUrl, name, overflowCount, size, border, ...props }) => {
  const initials = useMemo(() => {
    if (!name) return '';
    return name
      .split(' ')
      .map(word => word[0])
      .join('');
  }, [name]);

  if (avatarUrl)
    return (
      <StyledAvatar
        backgroundUrl={avatarUrl}
        height={size}
        width={size}
        border={border}
        {...props}
      />
    );

  if (overflowCount) {
    return (
      <StyledAvatar height={size} width={size} border={border} {...props}>
        <Text color={colors.mutedText} fontFamily="sans">{`+${overflowCount}`}</Text>
      </StyledAvatar>
    );
  }

  if (initials) {
    return (
      <StyledAvatar height={size} width={size} border={border} {...props}>
        <Text color={colors.mutedText} fontFamily="sans">
          {initials}
        </Text>
      </StyledAvatar>
    );
  }

  return (
    <StyledAvatar height={size} width={size} border={border} {...props}>
      <Box color={colors.mutedText}>
        <FontAwesome name="user" />
      </Box>
    </StyledAvatar>
  );
};

Avatar.propTypes = {
  avatarUrl: PropTypes.string,
  overflowCount: PropTypes.number,
  name: PropTypes.string,
  border: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
};

Avatar.defaultProps = {
  name: '',
  overflowCount: 0,
  size: 36,
  border: false,
  avatarUrl: '',
};

export default Avatar;
